import { render, staticRenderFns } from "./UserViewDistributionList.vue?vue&type=template&id=6f4b9660&scoped=true&"
import script from "./UserViewDistributionList.vue?vue&type=script&lang=js&"
export * from "./UserViewDistributionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4b9660",
  null
  
)

export default component.exports